import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { rootRoute } from "./root";

// Public: the screen pass from a one-time setup link is the only access, so the tablet never holds a session.
export const clockKioskRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "clock-kiosk",
  component: lazyRouteComponent(() => import("domains/gigs/views/ClockKiosk"), "ClockKioskView"),
});
